/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMini,
    ElementsUserMiniFromJSON,
    ElementsUserMiniFromJSONTyped,
    ElementsUserMiniToJSON,
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
    Subtask,
    SubtaskFromJSON,
    SubtaskFromJSONTyped,
    SubtaskToJSON,
    TaskProgress,
    TaskProgressFromJSON,
    TaskProgressFromJSONTyped,
    TaskProgressToJSON,
    Workstation,
    WorkstationFromJSON,
    WorkstationFromJSONTyped,
    WorkstationToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskInfo
 */
export interface TaskInfo {
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    readonly displayName: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TaskInfo
     */
    readonly kwargs: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TaskInfo
     */
    readonly outputs: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Subtask}
     * @memberof TaskInfo
     */
    subtask?: Subtask | null;
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof TaskInfo
     */
    worker?: StorageNodeMini | null;
    /**
     * 
     * @type {ElementsUserMini}
     * @memberof TaskInfo
     */
    user?: ElementsUserMini;
    /**
     * 
     * @type {Workstation}
     * @memberof TaskInfo
     */
    workstation?: Workstation;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskInfo
     */
    progress: TaskProgress;
    /**
     * 
     * @type {Date}
     * @memberof TaskInfo
     */
    readonly finished?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    taskName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInfo
     */
    isPrivate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    workerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    queue?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskInfo
     */
    state?: TaskInfoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    stateText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    jobInstance?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TaskInfo
     */
    readonly started: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInfo
     */
    isRunning?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInfo
     */
    isFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    exception?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInfo
     */
    traceback?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskInfo
     */
    schedule?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum TaskInfoStateEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7
}

export function TaskInfoFromJSON(json: any): TaskInfo {
    return TaskInfoFromJSONTyped(json, false);
}

export function TaskInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['display_name'],
        'kwargs': json['kwargs'],
        'outputs': json['outputs'],
        'subtask': !exists(json, 'subtask') ? undefined : SubtaskFromJSON(json['subtask']),
        'worker': !exists(json, 'worker') ? undefined : StorageNodeMiniFromJSON(json['worker']),
        'user': !exists(json, 'user') ? undefined : ElementsUserMiniFromJSON(json['user']),
        'workstation': !exists(json, 'workstation') ? undefined : WorkstationFromJSON(json['workstation']),
        'progress': TaskProgressFromJSON(json['progress']),
        'finished': !exists(json, 'finished') ? undefined : (json['finished'] === null ? null : new Date(json['finished'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taskName': !exists(json, 'task_name') ? undefined : json['task_name'],
        'isPrivate': !exists(json, 'is_private') ? undefined : json['is_private'],
        'workerName': !exists(json, 'worker_name') ? undefined : json['worker_name'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'stateText': !exists(json, 'state_text') ? undefined : json['state_text'],
        'jobInstance': !exists(json, 'job_instance') ? undefined : json['job_instance'],
        'started': (new Date(json['started'])),
        'isRunning': !exists(json, 'is_running') ? undefined : json['is_running'],
        'isFinished': !exists(json, 'is_finished') ? undefined : json['is_finished'],
        'exception': !exists(json, 'exception') ? undefined : json['exception'],
        'traceback': !exists(json, 'traceback') ? undefined : json['traceback'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
    };
}

export function TaskInfoToJSON(value?: TaskInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subtask': SubtaskToJSON(value.subtask),
        'worker': StorageNodeMiniToJSON(value.worker),
        'user': ElementsUserMiniToJSON(value.user),
        'workstation': WorkstationToJSON(value.workstation),
        'progress': TaskProgressToJSON(value.progress),
        'name': value.name,
        'task_name': value.taskName,
        'is_private': value.isPrivate,
        'worker_name': value.workerName,
        'queue': value.queue,
        'state': value.state,
        'state_text': value.stateText,
        'job_instance': value.jobInstance,
        'is_running': value.isRunning,
        'is_finished': value.isFinished,
        'exception': value.exception,
        'traceback': value.traceback,
        'schedule': value.schedule,
    };
}


